import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

import { AppDispatch, RootState } from 'redux/store';
import { fetchTransactionDetails } from 'redux/slices/transaction/transactionDetails';
import TransactionDetails from 'pages/Community/TransactionDetails';
import { getFullName } from 'utils/helpers';

const TransactionDetailContainer = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams();
    const location = useLocation();
    const { details, loading } = useSelector((state: RootState) => state.transaction);
    const { type } = location?.state || {};
    const { amount, confirmationCode, transactionDateTime, consumer, transactionStatus, canRequestRefund } = details || {};
    const { firstName, lastName, username, imgUrl } = consumer || {};
    useEffect(() => {
        id && dispatch(fetchTransactionDetails(id));
    }, [id, dispatch]);

    return (
        <TransactionDetails
            type={type}
            loading={loading}
            details={{
                confirmationCode,
                transactionDateTime,
                balance: amount,
                name: getFullName({ firstName, lastName }),
                username,
                logoUrl: imgUrl,
                status: transactionStatus,
                // TODO: THIS NEED TO BE IMPLEMENTED WHEN issue refund issue fixed so backed handle properly the canRequestRefund flag
                // canRequestRefund,
            }}
        />
    );
};

export default TransactionDetailContainer;
